import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { getUID, slice, toString, attrAccept, traverseFileTree, isCanChunkUpload } from '../utils';
import Props from './props';
import defaultRequest from './request';
import chunkRequest from './chunkRequest';
export default {
  name: 'AjaxUploader',
  props: _objectSpread({}, Props),
  data: function data() {
    return {
      uid: getUID()
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    }
  },
  created: function created() {
    this.reqs = {};
  },
  beforeDestroy: function beforeDestroy() {
    this.abort();
  },
  methods: {
    onClick: function onClick() {
      var fileInput = this.$refs.fileInput;

      if (fileInput) {
        fileInput.click();
      }
    },
    onKeyDown: function onKeyDown(e) {
      var keyCode = e.keyCode,
          onClick = e.onClick;

      if (keyCode === 13) {
        onClick();
      }
    },
    onDrop: function onDrop(e) {
      var directory = this.directory,
          accept = this.accept;
      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (directory) {
        traverseFileTree(e.dataTransfer.items, this.uploadFiles, function (_file) {
          return attrAccept(_file, accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return attrAccept(file, accept);
        });
        this.uploadFiles(files);
      }
    },
    onReady: function onReady(file) {
      this.$emit('ready', file);
    },
    onStart: function onStart(file) {
      this.$emit('start', file);
    },
    onProgress: function onProgress(e, file) {
      this.$emit('progress', e, file);
    },
    onSuccess: function onSuccess(ret, file, xhr) {
      this.$emit('success', ret, file, xhr);
    },
    onError: function onError(err, ret, file) {
      this.$emit('error', err, ret, file);
    },
    onChunkSend: function onChunkSend(chunk) {
      this.$emit('chunk-send', chunk);
    },
    onChunkSuccess: function onChunkSuccess(ret, chunk) {
      this.$emit('chunk-success', ret, chunk);
    },
    onChunkError: function onChunkError(err, ret, chunk) {
      this.$emit('chunk-error', err, ret, chunk);
    },
    post: function post(file) {
      var reqs = this.reqs,
          name = this.name,
          customRequest = this.customRequest,
          chunk = this.chunk,
          headers = this.headers,
          withCredentials = this.withCredentials,
          action = this.action,
          data = this.data,
          maxChunkSize = this.maxChunkSize,
          uploadedBytes = this.uploadedBytes,
          onStart = this.onStart,
          _onProgress = this.onProgress,
          _onSuccess = this.onSuccess,
          _onError = this.onError,
          onChunkSend = this.onChunkSend,
          onChunkSuccess = this.onChunkSuccess,
          onChunkError = this.onChunkError;
      var promises = [action, data].map(function (fn) {
        return Promise.resolve(isFunction(fn) ? fn(file) : fn);
      });
      Promise.all(promises).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            formAction = _ref3[0],
            formData = _ref3[1];

        var uid = file.uid;
        var request = customRequest || defaultRequest;
        var options = {
          action: formAction,
          fileName: name,
          data: formData,
          file: file,
          headers: headers,
          withCredentials: withCredentials,
          onProgress: function onProgress(e) {
            _onProgress(e, file);
          },
          onSuccess: function onSuccess(ret, xhr) {
            delete reqs[uid];

            _onSuccess(ret, file, xhr);
          },
          onError: function onError(err, ret) {
            delete reqs[uid];

            _onError(err, ret, file);
          }
        };

        if (isCanChunkUpload(chunk)) {
          chunkRequest(request, reqs)(_objectSpread({}, options, {
            maxChunkSize: maxChunkSize,
            uploadedBytes: uploadedBytes,
            onChunkSend: onChunkSend,
            onChunkSuccess: onChunkSuccess,
            onChunkError: onChunkError
          }));
        } else {
          reqs[uid] = request(options);
        }

        onStart(file);
      }).catch(function (err) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line
          console && console.error(' Error: action or data %s', err);
        }
      });
    },
    upload: function upload(file, files) {
      var beforeUpload = this.beforeUpload,
          post = this.post;

      if (!isFunction(beforeUpload)) {
        post(file);
        return;
      }

      var before = beforeUpload(file, files);

      if (before && isFunction(before.then)) {
        before.then(function (beforeFile) {
          var beforeFileType = toString.call(beforeFile);

          if (beforeFileType === '[object File]' || beforeFileType === '[object Blob]') {
            // TODO: 使用返回的beforeFile, onReady并没有收集到可能会有会有bug,需修正!! -- hw
            post(beforeFile);
            return;
          }

          if (beforeFile !== false) {
            post(file);
          }
        }, function (err) {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line
            console && console.error('Error: before-upload %s', err);
          }
        });
      } else if (before !== false) {
        post(file);
      }
    },
    uploadCheck: function uploadCheck(files) {
      var beforeReady = this.beforeReady;
      return Promise.resolve(isFunction(beforeReady) ? beforeReady(files) : true).catch(function (err) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line
          console && console.error('Error: before-ready %s', err);
        }

        return false;
      });
    },
    uploadFiles: function uploadFiles(fileList) {
      var upload = this.upload,
          onReady = this.onReady,
          autoUpload = this.autoUpload,
          uploadCheck = this.uploadCheck;
      var files = slice.call(fileList);
      uploadCheck(files).then(function (check) {
        if (check === false) {
          return;
        }

        files.forEach(function (file) {
          var nFile = file;
          nFile.uid = getUID();
          onReady(nFile);

          if (autoUpload) {
            upload(nFile, files);
          }
        });
      });
    },
    replaceFileInput: function replaceFileInput() {
      this.uid = getUID();
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uuid = file;

        if (file && file.uid) {
          uuid = file.uid;
        }

        if (reqs[uuid]) {
          reqs[uuid].abort();
          delete reqs[uuid];
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    },
    onChange: function onChange(e) {
      var replaceFileInput = this.replaceFileInput,
          uploadFiles = this.uploadFiles;
      var files = e.target.files;
      uploadFiles(files);
      replaceFileInput();
    }
  },
  render: function render() {
    var h = arguments[0];
    var slotDefault = this.$slots.default,
        classes = this.classes,
        disabled = this.disabled,
        CMP = this.component,
        uid = this.uid,
        accept = this.accept,
        directory = this.directory,
        multiple = this.multiple,
        onClick = this.onClick,
        onKeyDown = this.onKeyDown,
        onDrop = this.onDrop,
        onChange = this.onChange;
    var on = disabled ? {} : {
      click: onClick,
      keydown: onKeyDown,
      drop: onDrop,
      dropover: onDrop
    };
    var inputAttrs = {
      type: 'file',
      accept: accept,
      directory: !!directory,
      webkitdirectory: !!directory,
      multiple: multiple
    };
    var inputOn = {
      change: onChange
    };
    return h(CMP, _mergeJSXProps2([{}, {
      class: classes,
      attrs: {
        role: 'button',
        tabindex: 0
      },
      on: on
    }]), [h("input", _mergeJSXProps([{
      "directives": [{
        name: "show",
        value: false
      }]
    }, {
      key: uid,
      attrs: inputAttrs,
      on: inputOn,
      ref: 'fileInput'
    }])), slotDefault]);
  }
};